module.exports = __webpack_public_path__ + "img/权限.8195efb8.svg";